
import styled from "styled-components"

const Alert = styled.div`
	
	margin-bottom: 20px;
	height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: var(--color-label, lightblue);
    line-height: 22px; 
	
	opacity : ${ props => props.visible ? "1" : "0"};

	-webkit-transition: opacity 0.3s ease-in-out;
	-moz-transition: opacity 0.3s ease-in-out;
	-ms-transition: opacity 0.3s ease-in-out;
	-o-transition: opacity 0.3s ease-in-out;
	transition: opacity 0.3s ease-in-out;

`

Alert.Bordered = styled(Alert)`
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 4px;
    padding: 20px;
`

export default Alert